import { useEffect, useRef, useState } from "react";
import { Input, Select, Form } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import styles from "./MultipleInputs.module.scss";
import PhoneInput from "react-phone-input-2";
import MondayButton from "../../../commonComponents/MondayButton/MondayButton";
import { PlusIcon } from "../../../../assets/icons";
import { useSelector } from "react-redux";

const MultipleInputs = ({
  name: formItemName,
  label,
  value,
  dynamicFields,
  form,
}) => {
  const bottomRef = useRef(null);
  const { isDarkMode } = useSelector((state) => state.usersList);

  const initialValue = Array.isArray(value) ? value : value ? [value] : [{}];
  const [rows, setRows] = useState(initialValue);

  const addRow = () => {
    const newRow = dynamicFields.reduce((acc, field) => {
      acc[field.formItemName] = "";
      return acc;
    }, {});

    setRows((prevRows) => {
      const updatedRows = [...prevRows, newRow];
      handleRowChange(updatedRows);
      return updatedRows;
    });
  };

  const removeRow = (index) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows.splice(index, 1);
      handleRowChange(updatedRows);
      return updatedRows;
    });
  };

  const handleInputChange = (index, fieldName, value) => {
    setRows((prevRows) =>
      prevRows.map((row, i) =>
        i === index ? { ...row, [fieldName]: value } : row
      )
    );
  };

  const handlePhoneNumberChange = (index, fieldName, value) => {
    handleInputChange(index, fieldName, value.replace(/^\+/, ""));
  };

  const handleRowChange = (updatedRows) => {
    form.setFieldsValue({
      [formItemName]: updatedRows,
    });
  };

  const renderInput = (field, row, index) => {
    const { formItemName, type, disabled, options = [] } = field;

    switch (type) {
      case "Input":
      case "Email":
        return (
          <Input
            value={row[formItemName]}
            type={type === "Email" ? "email" : "text"}
            disabled={disabled}
            onChange={(e) =>
              handleInputChange(index, formItemName, e.target.value)
            }
          />
        );
      case "PhoneNumber":
        return (
          <PhoneInput
            disableCountryGuess
            {...{
              country: "al",
              onlyCountries: ["al", "xk"],
              disableCountryCode: false,
              disabled,
              specialLabel: "",
              copyNumbersOnly: false,
            }}
            value={row[formItemName]}
            onChange={(value) =>
              handlePhoneNumberChange(index, formItemName, value)
            }
          />
        );

      case "ComboBox":
        return (
          <Select
            value={row[formItemName]}
            disabled={disabled}
            maxTagCount={1}
            popupClassName={isDarkMode ? "darkDropdown" : ""}
            onChange={(value) => handleInputChange(index, formItemName, value)}
            showSearch
            allowClear
            filterOption={(input, option) =>
              option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            placeholder={`Zgjidh ${field.label.toLowerCase()}`}
          >
            {options.map((option) => (
              <Select.Option key={option} value={option}>
                {option}
              </Select.Option>
            ))}
          </Select>
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    bottomRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  }, [rows]);

  return (
    <div className={`${styles.container} ${isDarkMode ? styles.dark : ""}`}>
      {rows.map((row, index) => (
        <div key={index} className={styles.rowContainer}>
          <div className={styles.inputContainer}>
            <span className={styles.inputContainerHeader}>
              Kontakti i emergjencës #{index + 1}
              {rows.length !== 1 ? (
                <span
                  className={styles.removeBtn}
                  onClick={() => removeRow(index)}
                >
                  <CloseOutlined />
                </span>
              ) : null}
            </span>
            {dynamicFields.map((field) => {
              const fieldName = [formItemName, index, field.formItemName];
              return (
                <div key={field.formItemName}>
                  <span className={styles.label}>
                    <span style={{ color: "#ff0000" }}>* </span>
                    {field.label}:
                  </span>
                  <Form.Item
                    name={fieldName}
                    rules={field.rules || []}
                    validateTrigger={["onChange", "onBlur"]}
                    initialValue={row[field.formItemName]}
                  >
                    {renderInput(field, row, index)}
                  </Form.Item>
                </div>
              );
            })}
          </div>
        </div>
      ))}
      <MondayButton
        Icon={<PlusIcon />}
        className={"mondayButtonBlue"}
        onClick={addRow}
      >
        {`Shto ${label || "Rresht"} `}
      </MondayButton>
      <div ref={bottomRef} />
    </div>
  );
};

export default MultipleInputs;
